import React from 'react'
import PropTypes from 'prop-types'

import imagePlaceholder from 'images/no_image_full.png'
import IsCssSupported from 'Utils/IsCssSupported'

class NewsCard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isCoverImageSupported: false,
      imageSrc: props.image || imagePlaceholder,
    }

    this.handleImageErrored = this.handleImageErrored.bind(this)
  }

  componentDidMount() {
    this.setState({ isCoverImageSupported: IsCssSupported('objectFit') })
  }

  handleImageErrored() {
    this.setState({ imageSrc: imagePlaceholder })
  }

  render() {
    let imageStyles = {}

    if (!this.state.isCoverImageSupported) {
      imageStyles = { backgroundImage: `url(${this.state.imageSrc})` }
    }

    return (
      <a
        className={`news-card${this.props.cardModifier}`}
        href={this.props.url}
        target="_blank"
        rel="nofollow"
      >
        <div className="card">
          <div className="news-card__image-wrap">
            <div
              className={`news-card__image image-cover${!this.state.isCoverImageSupported ? ' image-cover--active' : ''}`}
              style={imageStyles}
            >
              <img
                onError={this.handleImageErrored}
                src={this.state.imageSrc}
                alt={this.props.title}
              />
            </div>
          </div>
          <div className="news-card__content">
            {this.props.children}
          </div>
        </div>
      </a>
    )
  }
}

NewsCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  image: PropTypes.string,
  cardModifier: PropTypes.string,
}

NewsCard.defaultProps = {
  image: '',
  cardModifier: '',
}

export default NewsCard
